<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <v-row>
          <v-col cols="12">
        <ValidationProvider
            rules="required"
            vid="name"
            :name="$t('fields.name').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.name"
            :counter="30"
            :label="$t('fields.name')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>
        <ValidationProvider
            vid="name"
            :name="$t('fields.alias').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.alias"
            :counter="30"
            :label="$t('fields.alias')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>
        <ValidationProvider
            rules="required"
            vid="code"
            :name="$t('fields.abbreviation').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.code"
            :counter="30"
            :label="$t('fields.abbreviation')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>
        <ValidationProvider
            rules="required"
            vid="grouped"
            :name="$t('fields.grouped').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.grouped"
            :counter="30"
            :label="$t('fields.grouped')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>

        <ValidationProvider
            rules="required"
            vid="type"
            :name="$t('fields.type').toLowerCase()"
            v-slot="{ errors }"
        >
        <v-select
          :items="types"
          v-model=" form.type"
          :label="$t('fields.type')"

          item-text="label"
          item-value="id"
          :error-messages="errors"
        ></v-select>
        </ValidationProvider>
      </v-col>
        </v-row>
    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import { schoolsTypesService } from '../../../utils/services/schoolsTypes.service';

  export default {
    name: 'SchoolTypeModal',
    data() {
      return {
        stored: null,
        schoolType: {},
        types: [
          { id: 0, label: this.$t('fields.elementary_school') },
          { id: 1, label: this.$t('fields.primary_school') },
          { id: 2, label: this.$t('fields.secondary_school') },
        ],
        form: {
          name: null,
          alias: null,
          code: null,
          grouped: null,
          type: null,

        },
        loading: false,
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
      isElementary() {
        return this.form.type === 0 ? 1 : 0;
      },
      isPrimary() {
        return this.form.type === 1 ? 1 : 0;
      },
      isSecondary() {
        return this.form.type === 2 ? 1 : 0;
      },
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              const form = { ...this.form,
...{
                  is_elementary: this.isElementary,
                  is_primary: this.isPrimary,
                  is_secondary: this.isSecondary },
              };

              this.options.onSave(
                form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  this.handleError(error, this.errors);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },
      fetchSchoolType(id) {
        return schoolsTypesService.get(id)
        .then(response => {
            this.schoolType = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

    },
    async created() {
      this.loadingModal(true);
      if (this.data.stored.id) {
        await this.fetchSchoolType(this.data.stored.id);


        let type;

        if (this.schoolType.options && this.schoolType.options.is_elementary) {
          type = 0;
        } else if (this.schoolType.options && this.schoolType.options.is_primary) {
          type = 1;
        } else if (this.schoolType.options && this.schoolType.options.is_secondary) {
          type = 2;
        }

        this.form = {
          id: this.data.stored.id,
          name: this.schoolType.name,
          alias: this.schoolType.alias,
          code: this.schoolType.code,
          grouped: this.schoolType.grouped,
          type,
          is_elementary: 0,
          is_primary: 0,
          is_secondary: 0,
        };
      }
      this.loadingModal(false);
    },
  };
</script>
